export default __webpack_public_path__ + "static/media/methane_BEIS_2019.ad61d719.png";